import { useMemo } from 'react';
import type { PermissionKey } from '../models/permission';
import { useUserPermissions } from '../queries/permission.queries';

/**
 * Utility hook for checking specific permissions
 * Returns permission check functions and loading state
 */
export const usePermissionCheck = (convId?: Nullable<string>) => {
  const { data, isLoading, isError } = useUserPermissions(convId);

  const permissions = useMemo(() => data?.permissions ?? [], [data]);
  const role = data?.role;

  const hasPermission = useMemo(() => (key: PermissionKey | string) => permissions.includes(key), [permissions]);

  const hasAnyPermission = useMemo(
    () => (keys: (PermissionKey | string)[]) => keys.some((k) => permissions.includes(k)),
    [permissions]
  );

  const hasAllPermissions = useMemo(
    () => (keys: (PermissionKey | string)[]) => keys.every((k) => permissions.includes(k)),
    [permissions]
  );

  return {
    permissions,
    role,
    isLoading,
    isError,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions
  };
};
